import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class GoalTestAttribute extends CypressAttribute {
  static inputs = {
    CUSTOM_GOAL: 'GoalTestAttribute:inputs:CUSTOM_GOAL'
  };

  static buttons: Record<string, string> = {
    GOAL_TYPE_BUTTON: 'GoalTestAttribute:buttons:GOAL_TYPE_BUTTON',
    GOAL_TYPE_BUTTON_TEXT: 'GoalTestAttribute:buttons:GOAL_TYPE_BUTTON_TEXT'
  };

  static views: Record<string, string> = {
    GOALS: 'GoalTestAttribute:views:GOALS'
  };
}
